export default __webpack_public_path__ + "static/media/llama.059910af.png";